<template>
  <div class="screen-shot-wrapper" v-if="screenShotData">
    <div 
      ref="screenshot"
      class="screen-component" 
      v-show="showScreenShot"
    >
      <component 
        :is="screenShotData.component_name" 
        :config="screenShotData.component_config"
      ></component>
    </div>
  </div>
</template>

<script>
import { getUrlParam, executeProtocol } from '_lib/utils'
import ShotHedan from './components/hedan.vue'
import ShotLuckCard from './components/luck-card.vue'

export default {
  props: {
    screenShotData: {
      type: Object,
      default: () => {}
    },
    showScreenShot: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.act_id = getUrlParam('act_id')
  },
  watch: {
    showScreenShot (n) {
      if (n) {
        setTimeout(() => {
          this.screenShotHandler()
        }, 0)
      }
    }
  },
  methods: {
    screenShotHandler () {
      window.shot_screen_top = document.documentElement.scrollTop || document.body.scrollTop
      setTimeout(() => {
        let dom = this.$refs['screenshot'].children[0]
        if (!dom) {
          return
        }
        this.$parent.is_jump_from_screenshot = true
        executeProtocol({
          "protocol_type":  "screenShotShare",
          "rects":  [{
            "top": document.querySelector('#outer-content').clientHeight,
            "width": dom.clientWidth,
            "left":  "0",
            "height": dom.clientHeight
          }],
          "share_title": this.screenShotData.component_config.share_desc,
          "share_url":  'https://api.xiaoheihe.cn/open_inapp/#heybox://' + encodeURIComponent(JSON.stringify({
            "protocol_type": "openWindow",
            "webview": {
              "url": `${window.location.origin}${window.location.pathname}?act_id=` + this.act_id
            },
            "navigation_bar": {
              "title": this.screenShotData.component_config.share_title
            }
          })),
          "delay":  "500",
          "act_id":  "_opentaskact" + this.act_id,
          "jsCallbackFunc":  "onScreenShared()",
        })
      }, 0);
    }
  },
  components: {
    ShotHedan,
    ShotLuckCard
  }
}
</script>

<style lang="less">

</style>